import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';

import SoftCardPRank from '../../components/SoftCardPRank/SoftCardPRank';
import { CONTEXT } from '../../config';
import styles from './ThreeColumnRank.module.less';
import { cleanSearchRecommend } from '../../actions/search';
import { logging, logPostInfo } from '../../actions/log';
import GameLink from '../../components/GameLink/GameLink';
import { useInView } from 'react-intersection-observer';
import { generateURL } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(cardData => {
  const { data = {}, logInfo } = cardData;
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const showSize = 5;
  const LOG_ACTION_SOURCE = {
    c_more: `${logInfo.tag}_Rank_More`,
    source: `${logInfo.tag}_Rank`,
    source_app: `${logInfo.tag}_Rank`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      if (data && data.dataList && data.dataList.length > 1) {
        data.dataList.forEach(item => {
          logInfo.changView({
            pageCardId: item.pageCardContentId,
            pageCardTitle: data && data.title,
            rankCode: item.code,
            cardType: data && data.cardType,
            org: item.org,
          });
        });
      }
    }
  }, [inView]);

  const handleShowMore = useCallback(
    rankData => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_more,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${rankData.code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(`${CONTEXT}/rankmore?code=${rankData.code}`);
      dispatch(cleanSearchRecommend());
    },
    [dispatch, logInfoData],
  );

  return (
    (data.dataList && data.dataList.length > 2 && (
      <div className={styles.card} ref={ref}>
        {data.dataList.map((item, index) => {
          return (
            <div className={styles.card_column} key={index}>
              <div className={`${styles[`card_header${index + 1}`]}`}>
                <div className={styles.card_header_title}>{item.name}</div>
                {item.apps.length > 5 && data.source !== 'game' && (
                  <div
                    className={styles.card_header_more}
                    onClick={() => {
                      handleShowMore(item);
                    }}
                  >
                    更多
                  </div>
                )}
                {item.apps.length > 5 && data.source === 'game' && (
                  <div className={styles.card_header_more}>
                    <GameLink
                      source={logInfo.tag}
                      to={generateURL(item)}
                      logInfo={{
                        category: 'C',
                        action: 'Game_New_More',
                        params: {
                          source: logInfo.tag,
                        },
                      }}
                    >
                      更多
                    </GameLink>
                  </div>
                )}
              </div>
              <div className={styles.content_column}>
                {item.apps.slice(0, showSize).map((soft, i) => (
                  <SoftCardPRank
                    soft={{ ...soft, cardShowDesc: true }}
                    logInfo={{
                      ...logInfo,
                      source: `${LOG_ACTION_SOURCE.source_app}||${item.code}`,
                    }}
                    key={i}
                    index={i + 1}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    )) ||
    null
  );
});
